import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from "react";
import { appendClassName } from "./view-helpers";

function ErrorBoundary(_ref) {
  var children = _ref.children,
      className = _ref.className,
      error = _ref.error,
      rest = _objectWithoutProperties(_ref, ["children", "className", "error"]);

  if (error) {
    return /*#__PURE__*/React.createElement("div", _extends({
      className: appendClassName("sui-search-error", className)
    }, rest), error);
  }

  return children;
}

export default ErrorBoundary;